import axios from "./axios";

export default {
  async getAllStaff() {
    const staff = await axios.getData(
      "/auth/get-all-staff",
      localStorage.getItem("token")
    );
    return staff;
  },

  async createStaff(name, idNumber, phone, email, city, address) {
    return axios.postDataWithToken(
      "/auth/create-staff",
      {
        name,
        idNumber,
        phone,
        email,
        city,
        address,
      },
      localStorage.getItem("token")
    );
  },
  async getAllPayrolls(url, branchID = null, conferenceID = null) {
    const payrolls = await axios.postDataWithToken(
      url,
      { branchID, conferenceID },
      localStorage.getItem("token")
    );
    return payrolls;
  },
  async addSelectedStaffToAPayroll(
    url,
    selectedEmployeesIDs,
    selectedPayrollID,
    branchID = null,
    conferenceID = null
  ) {
    const payslips = await axios.postDataWithToken(
      url,
      {
        selectedEmployeesIDs,
        selectedPayrollID,
        branchID,
        conferenceID,
      },
      localStorage.getItem("token")
    );
    return payslips;
  },
};
